/*
 * A/B Test PDP móvil v2 (Intelligems agrega html.hs-pdp-v2).
 * El markup de la variante ya viene renderizado en Liquid (oculto por CSS en control);
 * aquí solo se actualiza al cambiar de variante, se maneja la fila de riesgo y
 * se trackea en AMBOS brazos para poder comparar.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 768px)';

  function arm() {
    return document.documentElement.classList.contains('hs-pdp-v2') ? 'v2' : 'control';
  }

  function push(data) {
    window.dataLayer = window.dataLayer || [];
    data.hs_pdp_arm = arm();
    window.dataLayer.push(data);
  }

  function formatMoney(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  var currentPrice = null;
  var currentVariantId = null;
  var cartTotal = null;
  var cartVariantIds = null; // ids de variantes en el carrito, como strings

  function moneyNoDecimals(cents) {
    // moneyFormat trae <span class=money>; se quita para usarlo como texto
    return formatMoney(cents).replace(/<[^>]*>/g, '').replace(/\.00$/, '');
  }

  // Tiers desde assets/tier-discounts.js (única fuente), en centavos y ordenados
  function getTiers() {
    if (typeof discountTiers !== 'function') return null;
    var t = discountTiers();
    return [t.tierOne, t.tierTwo, t.tierThree]
      .filter(function (tier) { return tier && tier.threshold; })
      .map(function (tier) { return [tier.threshold * 100, tier.discountPct]; })
      .sort(function (a, b) { return a[0] - b[0]; });
  }

  // Lógica descrita en snippets/pdp-v2-money-line.liquid
  function updateMoneyLine() {
    var money = document.querySelector('[data-hs-money-line]');
    if (!money) return;
    var tiers = getTiers();
    // Sin config de tiers la línea se queda invisible (data-pending)
    if (!tiers || !tiers.length) return;
    // Valores iniciales del Liquid (server-side) hasta el primer variant:change / cart.js
    var cart = cartTotal !== null ? cartTotal : (parseInt(money.getAttribute('data-cart'), 10) || 0);
    var price = currentPrice !== null ? currentPrice : (parseInt(money.getAttribute('data-price'), 10) || 0);
    var variantId = currentVariantId !== null ? currentVariantId : money.getAttribute('data-variant');
    var inCart = cartVariantIds !== null
      ? cartVariantIds.indexOf(String(variantId)) !== -1
      : (money.getAttribute('data-cart-variants') || '').split(',').indexOf(String(variantId)) !== -1;
    // Si la pieza ya está en el carrito no se suma otra vez
    var projected = inCart ? cart : cart + price;

    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (cart < tiers[i][0]) { next = tiers[i]; break; }
    }
    var reached = tiers[0];
    for (var j = 0; j < tiers.length; j++) {
      if (projected >= tiers[j][0]) reached = tiers[j];
    }
    var completed = !next || projected >= next[0];

    var below = money.querySelector('[data-hs-money-state="below"]');
    var above = money.querySelector('[data-hs-money-state="above"]');
    if (completed) {
      above.querySelector('[data-hs-money-pct]').textContent = reached[1] + '%';
    } else {
      below.querySelector('[data-hs-money-pct]').textContent = next[1] + '%';
      below.querySelector('[data-hs-money-threshold]').textContent = moneyNoDecimals(next[0]);
    }
    below.hidden = completed;
    above.hidden = !completed;
    money.removeAttribute('data-pending');
  }

  // Total antes de descuentos, igual que snippets/tier-banner-pdp.liquid
  function applyCart(data) {
    if (!data || !data.items) return;
    cartTotal = data.items.reduce(function (sum, item) {
      var unit = (item.compare_at_price && item.compare_at_price > item.original_price)
        ? item.compare_at_price
        : item.original_price;
      return sum + unit * item.quantity;
    }, 0);
    cartVariantIds = data.items.map(function (item) { return String(item.variant_id); });
    updateMoneyLine();
  }

  var cartTimer;
  function refreshCart(e) {
    // El drawer custom manda el carrito en el evento: se usa directo, sin otra petición
    if (e && e.detail && e.detail.cart && e.detail.cart.items) {
      applyCart(e.detail.cart);
      return;
    }
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(applyCart)
        .catch(function () {});
    }, 150);
  }

  // Los nodos se buscan en cada evento: color-swatch-ajax.js reemplaza el HTML de la sección.
  function updateForVariant(variant) {
    if (!variant) return;

    currentPrice = variant.price;
    currentVariantId = variant.id;
    updateMoneyLine();

    var line = document.querySelector('[data-hs-sticky-line]');
    if (line) {
      var msiMin = parseInt(line.getAttribute('data-msi-min'), 10) || 0;
      var msiEl = line.querySelector('[data-hs-sticky-msi]');
      var eligible = variant.price >= msiMin;
      msiEl.textContent = 'o 6 MSI de ' + formatMoney(Math.round(variant.price / 6)).replace(/<[^>]*>/g, '');
      msiEl.hidden = !eligible;
      line.querySelector('[data-hs-sticky-returns]').hidden = eligible;
    }

    // La info row de la variante comparte markup con ig-sticky-v2; product-template.js
    // solo la actualiza con esa clase, así que aquí se cubre el precio en la variante.
    if (arm() === 'v2' && !document.body.classList.contains('ig-sticky-v2')) {
      var priceEl = document.querySelector('[data-ig-sticky-price]');
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      var compareEl = document.querySelector('[data-ig-sticky-compare]');
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
        compareEl.style.display = onSale ? '' : 'none';
      }
    }
  }

  function headerOffset() {
    var header = document.querySelector('.site-header');
    return header ? header.offsetHeight : 0;
  }

  function openShippingAccordion(row) {
    var targetId = row.getAttribute('aria-controls');
    var content = targetId && document.getElementById(targetId);
    if (!content) return;

    var trigger = document.querySelector('.collapsible-trigger[aria-controls="' + targetId + '"]');
    if (trigger && !trigger.classList.contains('is-open')) {
      trigger.click();
    }

    var anchor = trigger || content;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 8;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  document.addEventListener('variant:change', function (e) {
    updateForVariant(e.detail && e.detail.variant);
  });

  // color-swatch-ajax.js reemplaza la sección: el markup nuevo llega vacío (data-pending)
  // y trae precio/variante del otro producto en data-*; el carrito sigue siendo válido.
  document.addEventListener('hs:product-swapped', function () {
    currentPrice = null;
    currentVariantId = null;
    updateMoneyLine();
    observePriceBlock();
  });

  // Fila de info del sticky: solo cuando el precio de la página ya salió por arriba,
  // para no mostrar el precio duplicado al inicio. El CSS solo la usa con html.hs-pdp-v2.
  var priceObserver = null;
  function observePriceBlock() {
    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.add('hs-sticky-info-on');
      return;
    }
    if (priceObserver) priceObserver.disconnect();
    var priceBlock = document.querySelector('[data-section-type="product"] .product-block--price');
    if (!priceBlock) return;
    priceObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      document.documentElement.classList.toggle('hs-sticky-info-on', scrolledPast);
    });
    priceObserver.observe(priceBlock);
  }
  observePriceBlock();

  // Primer render (tier-discounts.js va con defer en el head, antes que este script)
  updateMoneyLine();


  // Cambios de carrito: evento del parche de tier-banner-pdp + eventos del tema
  ['cartcustom:updated', 'tierpdp:cart:updated', 'cart:updated', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, refreshCart);
  });
  // bfcache / volver desde el carrito
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('[data-hs-risk-row]');
    if (!row) return;
    push({ event: 'pdp_risk_row_click' });
    openShippingAccordion(row);
  });

  document.addEventListener('ajaxProduct:added', function (e) {
    var btn = e.detail && e.detail.addToCartBtn;
    // Solo el CTA del producto principal (no quick-add de recomendaciones)
    if (!btn || !btn.closest('.product-block--fixed')) return;
    var product = e.detail.product || {};
    push({
      event: 'pdp_add_to_cart',
      cta_location: window.matchMedia(MOBILE_QUERY).matches ? 'sticky' : 'inline',
      item_id: product.variant_id || product.id,
      price: product.price
    });
  });
})();
